import React, { useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./OrgSidebar";
import { FaRupeeSign } from 'react-icons/fa';
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { Dropdown } from 'react-bootstrap';
import { BsThreeDots } from 'react-icons/bs';
import {
  FaUniversity,
  FaBell,
  FaUserCircle
} from "react-icons/fa";
import {
  BsCheckCircle,
  BsBoxArrowUpRight
} from "react-icons/bs";
import { GiHamburgerMenu } from "react-icons/gi";
import { logout } from "../../redux/actions/AuthActions";
import { getPermissionByRole } from "../../redux/actions/PermissionAction";

const Layout = () => {
  const {
    AuthReducer: { isAuthenticated, auth },
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [width, setWidth] = useState(0);
  const [isMenue, setIsMenue] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAllNotificationsModal, setShowAllNotificationsModal] = useState(false);
  const [showUniversityModal, setShowUniversityModal] = useState(false);

  const aside = useRef(null);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    dispatch(getPermissionByRole(auth.roleId, auth.token, true));
  }, [auth]);

  useEffect(() => {
    if (aside.current) {
      setWidth(aside.current?.clientWidth);
    }
  }, [aside]);

  return (
    <Wrapper>
      <div className="header_wapper pt-2 pb-2">
        <div className="container-fluid pe-3 ps-3">
          <div className="row justify-content-center">
            <div className="col-md-3 d-flex justify-content-end">
              <div className={isMenue ? "active menu" : "menu"}>
                <GiHamburgerMenu
                  onClick={() => setIsMenue(!isMenue)}
                  size="25px"
                  color="white"
                />
              </div>
            </div>

            <div className="col-md-9 d-flex justify-content-end align-items-center gap-2 mt-2">
              <select className="form-select w-auto">
                <option>All Time</option>
                <option>This Month</option>
                <option>This Week</option>
                <option>Today</option>
              </select>

              {/* <div className="position-relative">
                <div className="btn btn-light p-2" style={{ borderRadius: "15%", cursor: "pointer" }}>
                  <FaUniversity size={18} className="text-dark" />
                </div>
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px' }}>
                  8
                </span>
              </div> */}
              <div className="position-relative">
                <div
                  className="btn btn-light p-2"
                  style={{
                    borderRadius: '15%',
                    cursor: 'pointer',
                    height: '37.45px',
                    lineHeight: '15px',
                  }}
                  onClick={() => setShowUniversityModal(true)} // 👈 Add this line
                >
                  <FaUniversity size={18} className="text-dark" />
                </div>
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px' }}>
                  8
                </span>
              </div>


              <div className="position-relative">
                <div
                  className="btn btn-light p-2"
                  style={{
                    borderRadius: '15%',
                    cursor: 'pointer',
                    height: '37.45px',
                    lineHeight: '15px',
                  }}
                  onClick={() => setShowModal(true)}
                >
                  <FaBell size={18} className="text-dark" />
                </div>
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px' }}>
                  7
                </span>
              </div>

              <div className="btn btn-light p-2" style={{
                borderRadius: '15%',
                cursor: 'pointer',
                height: '37.45px',
                lineHeight: '15px',
              }}>
                <FaUserCircle size={22} className="text-dark" />
              </div>
            </div>
          </div>

          <div className={isMenue ? "active dashboard" : "dashboard"}>
            <Outlet />
          </div>
        </div>
      </div>

      <div className="d-flex dashboard-wrapper bg-primary-100">
        <div
          style={{ zIndex: 100 }}
          className={isMenue ? "active sidebar_menu" : "sidebar_menu"}
          ref={aside}
        >
          <Sidebar />
        </div>
        <main
          className="main flex-grow-1 mt-4 main_bg"
          style={{ marginLeft: `${width}px`, transition: "all 500ms" }}
        ></main>
      </div>

      {/* setalment modal */}
      <Modal
        show={showUniversityModal}
        onHide={() => setShowUniversityModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Pending Settlement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-white rounded-lg">
            <div className="divide-y">
              <div className="d-flex align-items-start justify-content-between border p-2">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                      <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                  </div>
                  <div>
                    <div className="fw-semibold text-dark">Thrill Seeker Adventures</div>
                    <small className="text-muted">june 01 - june 30,2025</small>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-400 d-flex align-items-center">
                  <FaRupeeSign size={14} className="text-primary" />
                  <span className="text-primary">3480.50</span>
                </div>
              </div>
              <div className="d-flex align-items-start justify-content-between mt-3 border p-2">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                      <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                  </div>
                  <div>
                    <div className="fw-semibold text-dark">New Booking Received</div>
                    <small className="text-muted">joined the platform.</small>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-400 d-flex align-items-center">
                  <FaRupeeSign size={14} className="text-primary" />
                  <span className="text-primary">9480.50</span>
                </div>
              </div>
              <div className="d-flex align-items-start justify-content-between mt-3 border p-2">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                      <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                  </div>
                  <div>
                    <div className="fw-semibold text-dark">New Booking Received</div>
                    <small className="text-muted">joined the platform.</small>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-400 d-flex align-items-center">
                  <FaRupeeSign size={14} className="text-primary" />
                  <span className="text-primary">4180.50</span>
                </div>
              </div>
              <div className="d-flex align-items-start justify-content-between mt-3 border p-2">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                      <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                  </div>
                  <div>
                    <div className="fw-semibold text-dark">New Booking Received</div>
                    <small className="text-muted">joined the platform.</small>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-400 d-flex align-items-center">
                  <FaRupeeSign size={14} className="text-primary" />
                  <span className="text-primary">5980.50</span>
                </div>
              </div>
              <div className="d-flex align-items-start justify-content-between mt-3 border p-2">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                      <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                  </div>
                  <div>
                    <div className="fw-semibold text-dark">New Booking Received</div>
                    <small className="text-muted">joined the platform.</small>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-400 d-flex align-items-center">
                  <FaRupeeSign size={14} className="text-primary" />
                  <span className="text-primary">4580.50</span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            className="flex items-center gap-2 text-sm text-primary rounded-md bg-white border-0"
          // onClick={() => {
          //   setShowModal(false); // close first modal
          //   setShowAllNotificationsModal(true); // open second modal
          // }}
          >
            <BsBoxArrowUpRight className="text-base me-2" />
            View all notifications
          </button>
        </Modal.Footer>
      </Modal>

      {/* Notification Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <Modal.Title className="mb-0">Notifications </Modal.Title>
          </div>

          <div className="d-flex align-items-center gap-2">

            {/* <Dropdown>
              <Dropdown.Toggle
                variant="light"
                className="p-1 border bg-white"
                style={{
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // borderRadius: '50%',
                  Dropdown: 'none',
                }}
              >
                <BsThreeDots />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Mark all as read</Dropdown.Item>
                <Dropdown.Item>Clear all notification</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}

            <Dropdown
              align="end"
              autoClose="outside"
              popperConfig={{
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      boundary: 'clippingParents', // ensures it stays inside the modal
                    },
                  },
                ],
              }}
            >
              <Dropdown.Toggle
                variant="light"
                className="p-1 border bg-white"
                style={{
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // borderRadius: '50%',
                }}
              >
                <BsThreeDots />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Mark all as read</Dropdown.Item>
                <Dropdown.Item>Clear all notifications</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* <Dropdown>
              <Dropdown.Toggle
                variant="light"
                className="p-1  border"
                style={{
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <BsThreeDots />
              </Dropdown.Toggle>

              <Dropdown.Menu >
                <Dropdown.Item>Mark all as read</Dropdown.Item>
                <Dropdown.Item>Clear all notification</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}



            {/* <button
              type="button"
              className="btn-close"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            ></button> */}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="bg-white rounded-lg">
            <div className="divide-y">
              <div className="d-flex align-items-start justify-content-between">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                      <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                  </div>
                  <div>
                    <div className="fw-semibold text-dark">New Booking Received</div>
                    <small className="text-muted">joined the platform.</small>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-400">
                  <div>2m ago</div>
                  <div className="text-primary">View</div>
                </div>
              </div>

              <div className="d-flex align-items-start justify-content-between pt-3">
                <div className="d-flex align-items-start">
                  <div className="me-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                      <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                    </div>
                  </div>
                  <div>
                    <div className="fw-semibold text-dark">Partner Approval Pending </div>
                    <small className="text-muted">joined the platform.</small>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-400">
                  <div>2m ago</div>
                  <div className="text-primary">View</div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <button
            className="flex items-center gap-2 text-sm text-primary rounded-md bg-white border-0"
            onClick={() => {
              setShowModal(false); // close first modal
              setShowAllNotificationsModal(true); // open second modal
            }}
          >
            <BsBoxArrowUpRight className="text-base me-2" />
            View all notifications
          </button>
        </Modal.Footer>
      </Modal>

      {/* All Notifications Modal */}
      {/* <Modal
        show={showAllNotificationsModal}
        onHide={() => setShowAllNotificationsModal(false)}
        centered
        size="lg"

      > */}

      <Modal
        show={showAllNotificationsModal}
        onHide={() => setShowAllNotificationsModal(false)}
        centered
        dialogClassName="custom-modal-width"
      >

        <Modal.Header closeButton>
          <div className="w-100">
            <Modal.Title>All Notifications</Modal.Title>
            <p className="mb-0 text-muted" style={{ fontSize: '14px' }}>
              Your compleate notification history
            </p>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div style={{ height: "144px", overflowY: "auto" }}>
            <div className="d-flex align-items-start justify-content-between pt-3">
              <div className="d-flex align-items-start">
                <div className="me-3">
                  <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                    <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                  </div>
                </div>
                <div>
                  <div className="fw-semibold text-dark">New Booking Received!</div>
                  <small className="text-muted">Booking for Mountain Expedition</small>
                </div>
              </div>
              <div className="text-right text-sm text-gray-400">
                <div>2m ago</div>
                <div className="text-primary">View</div>
              </div>
            </div>
            <div className="d-flex align-items-start justify-content-between pt-3">
              <div className="d-flex align-items-start">
                <div className="me-3">
                  <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                    <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                  </div>
                </div>
                <div>
                  <div className="fw-semibold text-dark">Partner Approval Pending </div>
                  <small className="text-muted">joined the platform.</small>
                </div>
              </div>
              <div className="text-right text-sm text-gray-400">
                <div>2m ago</div>
                <div className="text-primary">View</div>
              </div>
            </div>
            <div className="d-flex align-items-start justify-content-between pt-3">
              <div className="d-flex align-items-start">
                <div className="me-3">
                  <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: 48, height: 48 }}>
                    <BsCheckCircle style={{ color: '#22c55e', fontSize: '24px' }} />
                  </div>
                </div>
                <div>
                  <div className="fw-semibold text-dark">Refund Requested</div>
                  <small className="text-muted">joined the platform.</small>
                </div>
              </div>
              <div className="text-right text-sm text-gray-400">
                <div>2m ago</div>
                <div className="text-primary">View</div>
              </div>
            </div>
          </div>
        </Modal.Body>

      </Modal>
    </Wrapper>
  );
};

const Wrapper = styled.div`

  .dropdown-toggle::after {
    display: none !important;
  }
     .dropdown-toggle {
    display: none !important;
  }
  .header_wapper {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    color: #fff;
    border-bottom: 1px solid #fff;
    background-color: #0c0634d1;
    height: 400px;
  }
  .sidebar_menu {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #fff;
    overflow: auto;
    transition: all 0.3s;
  }
  .sidebar_menu.active {
    overflow-x: hidden;
    width: 125px;
    transition: all 0.3s;
  }
  .dashboard.active {
    padding-left: 160px;
    background-color: #383359;
    height: 200px;
  }
  .dashboard {
    padding-left: 240px;
  }
  .main {
    padding-inline: 2.5rem;
    padding-top: 2rem;
  }
  .main_bg {
    background: #f8f8f8 !important;
  }
  .menu {
    position: relative;
    margin-right: 75px;
    cursor: pointer;
  }
  .menu.active {
    margin-right: 160px;
    background-color: #383359;
  }

  .custom-modal-width .modal-dialog {
      width: 500px; 
    }
`;

export default Layout;
